import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  isIe: boolean;
}

export const Wrapper = styled.div`
  background-color: #3b045e;
  color: #fff;
  padding-top: ${(props: IWrapperProps) => (props.isIe ? "119px" : "94px")};
  display: flex;
  justify-content: center;
  min-height: 710px;

  ${mediaMaxWidth.smallDesktop} {
    padding-top: 48px;
    padding-top: ${(props: IWrapperProps) => (props.isIe ? "73px" : "48px")};
  }

  ${mediaMaxWidth.phone} {
    min-height: 100vh;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInDown {
    animation-name: fadeInDown;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInUp {
    animation-name: fadeInUp;
  }

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInLeft {
    animation-name: fadeInLeft;
  }

  .animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  .animated.delay-1 {
    animation-delay: 0.15s;
  }

  .animated.delay-2 {
    animation-delay: 0.3s;
  }

  .animated.delay-3 {
    animation-delay: 0.45s;
  }

  .animated.delay-4 {
    animation-delay: 0.6s;
  }

  .animated.delay-5 {
    animation-delay: 0.75s;
  }

  .animated.delay-6 {
    animation-delay: 0.9s;
  }

  .animated.delay-7 {
    animation-delay: 1.05s;
  }

  .animated.delay-8 {
    animation-delay: 1.2s;
  }
`;

export const FormWrapper = styled.div`
  width: 800px;
`;

export const Title = styled.h3`
  text-align: center;
  line-height: 3rem;
  font-size: 1.875rem;
  color: #fff;
  font-weight: 500;
  margin: 40px 0 10px 0;

  ${mediaMaxWidth.tablet} {
    font-size: 1.55em;
    width: calc(100vw - 40px);
    margin: 30px auto 10px auto;
    line-height: 1.5em;
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: 1.4em;
  }
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  margin-bottom: 0;

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 40px);
    margin: 0 auto;
  }
`;

export const Field = styled.div`
  position: relative;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LoadingSpinner = styled.img`
  width: 50px;
`;

export const LoadingText = styled.div`
  font-size: 1.2em;
  margin-top: 30px;
`;

export const ErrorPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90%;

  span {
    font-size: 2.85em;
  }
`;

export const ErrorPageText = styled.div`
  font-size: 1.7em;
  margin-top: 30px;
  font-weight: 100;
  text-align: center;

  ${mediaMaxWidth.phone} {
    font-size: 1.4em;
  }
`;

export const LoggedInUserErrorPageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaMaxWidth.smallDesktop} {
    padding: 0 10px;
  }
`;

export const LoggedInUserErrorPageTitle = styled.h3`
  text-align: center;
  line-height: 3rem;
  font-size: 1.875rem;
  color: #fff;
  font-weight: 500;
  margin: 40px 0 10px 0;

  ${mediaMaxWidth.tablet} {
    font-size: 1.7rem;
  }

  ${mediaMaxWidth.phone} {
    font-size: 1.3rem;
    line-height: 2rem;
    margin: 30px 0 10px 0;
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: 1.2rem;
  }
`;

interface ILoggedInUserErrorPageTextProps {
  last?: boolean;
}

export const LoggedInUserErrorPageText = styled.p`
  margin: ${(props: ILoggedInUserErrorPageTextProps) =>
    props.last ? "30px 0 60px 0" : "30px 0"};
  font-size: 1.25em;
  font-weight: 100;

  ${mediaMaxWidth.tablet} {
    font-size: 1.2em;
  }

  ${mediaMaxWidth.phone} {
    font-size: 1.15em;
    margin: ${(props: ILoggedInUserErrorPageTextProps) =>
      props.last ? "15px 0 30px 0" : "15px 0"};
  }
`;

export const LoggedInUserErrorPageImage = styled.img`
  width: 350px;
  margin: 20px auto;
  border-radius: 8px;

  ${mediaMaxWidth.tablet} {
    width: 320px;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 80px);
  }

  ${mediaMaxWidth.smallPhone} {
    width: calc(100vw - 60px);
  }
`;
